module.exports = __webpack_public_path__ + "img/375.4be095f0.jpg";